<template>
<div class="chapter">
<div class="inner_page">
<div class="fs" id="page003">
<div class="jstfy" id="page003_1">CONTENTS</div>
<div class="jstfy" id="page003_2"><a href="#/page_006">French Cuisine<span class="page003_2a">   page 6</span></a></div>
<div class="jstfy" id="page003_3"><a href="#/page_011">Recipes<span class="page003_3a">   page 11</span></a></div>
<div class="jstfy" id="page003_4"><a href="#/page_013">BASICS</a></div>
<div class="jstfy" id="page003_5"><a href="#/page_013">page 13</a></div>
<div class="jstfy" id="page003_6"><span href="#/page_033" title="Link target outside of Sample">STARTERS</span></div>
<div class="jstfy" id="page003_7"><span href="#/page_033" title="Link target outside of Sample">page 33</span></div>
<div class="jstfy" id="page003_8"><span href="#/page_057" title="Link target outside of Sample">MAIN COURSES</span></div>
<div class="jstfy" id="page003_9"><span href="#/page_057" title="Link target outside of Sample">page 57</span></div>
<div class="jstfy" id="page003_10"><span href="#/page_117" title="Link target outside of Sample">DESSERTS</span></div>
<div class="jstfy" id="page003_11"><span href="#/page_117" title="Link target outside of Sample">page 11</span></div>
<div class="jstfy" id="page003_12"><span href="#/page_166" title="Link target outside of Sample">Index <span class="page003_12a">page 166</span></span></div>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// page_003.vue?434de21c